import {ProcessFlowchartPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {DefaultProcessFlowchartNodeAdapter} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';

import {getAdapterForNodeData} from './adapterUtils';
import {getAllNodeDetailsSidepanelTabsForTaskNodeData} from './getAllNodeDetailsSidepanelTabsForTaskNode';
import {
  isStaticPlaceholderNodeData,
  isStaticRouterNodeData,
  isStaticTaskSchemaNodeData,
  StaticFlowchartNodeData,
} from './processFlowchartConfigEditorNodeTypes';

/**
 * Determines whether a node has right sidepanel content that can be displayed.
 * Uses the node's adapter to check for sidepanel content.
 *
 * @param nodeData - The static node data to check
 * @param platformFlowchartFeatures - Platform features map (required for task schema nodes)
 * @returns true if the node has sidepanel content, false otherwise
 */
export default function doesNodeHaveRightSidepanelContent(
  nodeData: StaticFlowchartNodeData,
  platformFlowchartFeatures?: Map<ProcessFlowchartPlatformFeatureType, boolean>
): boolean {
  if (isStaticPlaceholderNodeData(nodeData)) {
    return true;
  }

  const adapter = getAdapterForNodeData(nodeData);
  if (adapter == null) {
    return false;
  }

  if (isStaticTaskSchemaNodeData(nodeData)) {
    const tabs = getAllNodeDetailsSidepanelTabsForTaskNodeData(nodeData, platformFlowchartFeatures);
    return tabs.length > 0;
  }

  if (adapter instanceof DefaultProcessFlowchartNodeAdapter) {
    return isStaticRouterNodeData(nodeData);
  }

  return false;
}
